/* eslint-disable max-len */
/* eslint-disable no-plusplus */
import React, {
  useEffect, useMemo, useRef, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '@mui/material';
import { TubeChartGrid } from './tubeChartGrid';
import {
  Circle,
  PolygonInterface,
  RemovedConfigType,
//   TubeConfiguration,
} from '../../../utils/tubeChartTypes';
import ComponentPageHeader from '../../../../../Common/PageHeader/ComponentPageHeader';
import { Polygon } from './gridClass';
import { RootState } from '../../../../../redux/rootState';
import {
  createTubeChartStart,
  getChartListSuccess,
  resetAddStates,
  setSectionValues,
  setSelectedSection,
} from '../../../redux/tubeChart/tubeChartSlice';
import { setLoader } from '../../../../../redux/loaderSlice';
import styles from './index.module.scss';
import { getUpdateTubePayload } from '../../../utils/helper/tubeChart';
import localStorageConstants from '../../../../../utils/LocalStorageConstants';
import { ANALYST_ROLE_ID } from '../../../../../Routes/constant';
import AddTubeChartPanel from './addTubeChartPanel';
import { sectionValues } from '../../../utils/tubeChartConstant';
import { showErrorToaster, showSuccessToaster } from '../../../../../Common/ComponentToast/ComponentSuccessToasts';
import ImportTubeChartModal from '../../../../../Common/ImportTubeChartModal/ComponentImportTubeChartModal';
import { importTubeChartFailure } from '../../../../tubeChartLibrary/redux/tubeChartLibrarySlice';

export function TubeDiagramAdd() {
  const roleId = localStorage.getItem(localStorageConstants.ROLE_ID);
  const [polygonList, setPolygonList] = useState<PolygonInterface[]>([]);
  const [polyCircles, setPolyCircles] = useState<Circle[][][]>([]);
  const [totalTubeCount, setTotalTubeCount] = useState(0);
  const [openImportModal, setOpenImportModal] = useState(false);
  const { importChartData } = useSelector((state: RootState) => state.TubeChartLibraryReducer);

  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(setSectionValues(sectionValues.filter((item) => item?.Value === '2')));
    dispatch(setSelectedSection('2'));
    return () => {
      dispatch(resetAddStates());
    };
  }, []);

  const {
    chartList, rows, tubesPerRow, offset, layout,
    selectedSection, isLoading, vesselTopRed, showLayout,
  } = useSelector((state:RootState) => state.TubeChartReducer);
  const {
    startScreenShot,
  } = useSelector((state:RootState) => state.VesselInformationReducer);
  const componentRef = useRef<HTMLDivElement>(null);

  const selectedSectionIndex = useMemo(() => {
    if (selectedSection) {
      return chartList.findIndex((details) => details.Panel === selectedSection);
    }
    return 0;
  }, [selectedSection, chartList?.length]);

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  function generateGrid(ro: number, tub: number) {
    const result = [];

    for (let r = 0; r < ro; r++) {
      for (let c = 0; c < tub; c++) {
        result.push({
          Position: `${r},${c}`,
          Stroke: '#FF000000',
          Fill: '#00FFFFFF',
        });
      }
    }

    return result;
  }

  const handleGenerate = () => {
    if (!(offset?.length > 0)) {
      showErrorToaster('Kindly choose Offset, Rows, Tubes per row, & Vessel Top to generate tube chart');
      return;
    }
    if (!(Number.isInteger(Number(rows)) && Number.isInteger(Number(tubesPerRow)))) {
      showErrorToaster('Please enter valid no. of Rows & Tubes per row');
      return;
    }
    if (!(Number(rows) > 0 && Number(tubesPerRow) > 0)) {
      showErrorToaster('No. of Rows & Tubes per row cannot be 0');
      return;
    }
    if (Number(rows) > 100) {
      showErrorToaster('You can add up to 100 rows.');
      return;
    }
    if (Number(tubesPerRow) > 130) {
      showErrorToaster('You can add up to 130 tubes per row.');
      return;
    }
    if (offset === '1' && !(Number(rows) === Number(tubesPerRow))) {
      showErrorToaster('Rows and Tubes must be equal in case of Top Offset');
      return;
    }
    const charts = [...chartList];
    const grid = generateGrid(Number(rows), Number(tubesPerRow));
    const payData = {
      ChartId: '',
      Group: '',
      IsOte: true,
      Layout: layout,
      NumOfRows: rows,
      Offset: offset,
      OriginalTestEnd: true,
      Panel: selectedSection,
      RemovedConfig: {} as RemovedConfigType,
      RowLength: tubesPerRow,
      TubeSize: 'Small',
      VesselTop: vesselTopRed,
      CircleInfos: grid,
      section: selectedSection,
    };
    charts.push(payData);
    const sortedCharts = charts?.sort((a, b) => Number(a.Panel) - Number(b.Panel));
    dispatch(getChartListSuccess(sortedCharts));
  };

  useEffect(() => {
    if (Object.keys(importChartData)?.length > 0) {
      showSuccessToaster('Tube Chart imported successfully');
      const charts = [...chartList];
      const payData = {
        ChartId: importChartData?.ChartId || '',
        Group: importChartData?.Group || '',
        IsOte: importChartData?.IsOte,
        Layout: layout,
        NumOfRows: importChartData?.NumOfRows,
        Offset: importChartData?.Offset,
        OriginalTestEnd: importChartData?.OriginalTestEnd,
        Panel: selectedSection,
        RemovedConfig: importChartData?.RemovedConfig,
        RowLength: importChartData?.RowLength,
        TubeSize: importChartData?.TubeSize || 'Small',
        VesselTop: importChartData?.VesselTop || 'Up',
        CircleInfos: importChartData?.CircleInfos,
        section: selectedSection,
      };
      charts.push(payData);
      const sortedCharts = charts?.sort((a, b) => Number(a.Panel) - Number(b.Panel));
      dispatch(getChartListSuccess(sortedCharts));
      dispatch(importTubeChartFailure());
      setOpenImportModal(false);
    }
  }, [importChartData]);

  //   useEffect(() => {
  //     if (chartList.length > 0) {
  //       const polyArr: PolygonInterface[] = [];

  //       const updatedPolyArr = chartList.map((poly) => ({
  //         ...poly,
  //         section: poly?.Panel,
  //         // section: chartList.length === 1 ? selectedSection : `${index + 1}`,
  //       }));

  //       updatedPolyArr.forEach((chartDetails: TubeConfiguration) => {
  //         const tempPoly = new Polygon(chartDetails);
  //         polyArr.push(tempPoly);
  //       });

  //       setPolygonList([...polyArr]);
  //     }
  //   }, [chartList]);
  useEffect(() => {
    if (chartList.length === 0) return;

    setPolygonList((prev) => {
      const newList: PolygonInterface[] = [];

      chartList.forEach((chartItem) => {
      // find polygon with same Panel
        const existing = prev.find((p) => p.section === chartItem.Panel);

        if (existing) {
        // keep previous polygon
          newList.push(existing);
        } else {
        // create new polygon only for NEW chart item
          newList.push(
            new Polygon({
              ...chartItem,
              section: chartItem.Panel,
            }),
          );
        }
      });
      return newList;
    });
  }, [chartList]);

  const handleUndo = () => {
    if (polygonList.length > 0) {
      polygonList[Number(selectedSectionIndex)].undo();
      const temp = [...polyCircles];
      temp[selectedSectionIndex] = polygonList[Number(selectedSectionIndex)].circles;
      setPolyCircles([...temp]);
    }
  };

  const handleSectionChange = (value:string) => {
    dispatch(setSelectedSection(value));
  };

  const handleSave = () => {
    const jobOrder = String(searchParams.get('jobOrder'));
    const vessel = String(searchParams.get('vessel'));
    const pay = getUpdateTubePayload(
      jobOrder,
      vessel,
      polygonList,
      chartList,
      vesselTopRed,
      false, // Indicate that this API call is NOT for adding to library
    );

    dispatch(createTubeChartStart({ pay, nav: navigate }));
    polygonList[Number(selectedSectionIndex)]?.ClearUndo();
    polygonList[Number(selectedSectionIndex)]?.removeDefects();
  };

  useEffect(() => {
    const totalCount = polygonList?.reduce((acc, curr:PolygonInterface) => acc + curr.totalVisible, 0);
    setTotalTubeCount(totalCount);
  }, [polygonList?.[Number(selectedSectionIndex)]?.totalVisible]);

  const tubeChartDirectionStyle = chartList?.[0]?.Layout === '2' ? styles.displayTubeRow : styles.displayBlock;
  const tubeChartDirectionScreenShotStyle = chartList?.[0]?.Layout === '2' ? styles.printDisplayTubeRow : styles.displayScreenShotBlock;

  const showSaveButton = useMemo(() => {
    if (showLayout) {
      if (chartList?.length === 3) {
        return true;
      } return false;
    }
    if (chartList?.length === 1) {
      return true;
    } return false;
  }, [showLayout, chartList]);
  const showGenerateButton = useMemo(() => {
    if (chartList.find((item) => item?.Panel === selectedSection)) {
      return false;
    } return true;
  }, [chartList, selectedSection]);

  return (
    <div className={styles.vesselTubeChartContainer}>
      <ComponentPageHeader subHeading="Tube Chart" />
      <AddTubeChartPanel
        handleUndo={handleUndo}
        handleSectionChange={handleSectionChange}
        tubeCount={polygonList?.[Number(selectedSectionIndex)]?.totalVisible}
        vesselTopVal="Up"
        isUndoDisable={polygonList?.[Number(selectedSectionIndex)]?.history?.length === 0}
        totalTubeCount={totalTubeCount}
      />
      {!(roleId === ANALYST_ROLE_ID) && (
      <div className={`${styles.vesselDiv} save_and_next_div`}>
        <div className="button_margin_left">
          {showSaveButton && <Button className="button_save_and_next" style={{ marginRight: '5px' }} onClick={handleSave}>Save</Button>}
          {showGenerateButton && <Button className="button_save_and_next" style={{ marginRight: '5px' }} onClick={() => setOpenImportModal(true)}>Import from Library</Button>}
          {showGenerateButton && <Button className="button_save_and_next" onClick={handleGenerate}>Generate Grid</Button>}
        </div>
      </div>
      )}
      <div ref={componentRef} className={startScreenShot ? tubeChartDirectionScreenShotStyle : tubeChartDirectionStyle}>
        {polygonList?.map((item, index) => (
          <TubeChartGrid
            polygon={item}
            polyCircles={polyCircles}
            index={index}
            setPolyCircles={setPolyCircles}
          />
        ))}
      </div>
      {openImportModal && (
      <ImportTubeChartModal
        show={openImportModal}
        setOpenFrom={() => setOpenImportModal(false)}
      />
      )}
    </div>
  );
}
